<template>
  <div class="content-accordion">
    <div class="el-collapse-item">
      <el-form
        inline-message
        :model="dataInfo"
        ref="dataInfo"
        label-width="110px"
        class="demo-user"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <template v-for="(title, index) in bigtitle">
            <el-tab-pane
              :key="index"
              label="单据类"
              name="first"
              v-if="bigtitle[index].title == '1'"
            >
              <el-tabs
                :tab-position="tabPosition"
                @tab-click="singleClick"
                :style="styleHeight"
              >
                <el-tab-pane
                  v-for="item in bigtitle[index].list"
                  :key="item.id"
                  :label="item.code"
                >
                  <div class="pull-left" style="width: 84%">
                    <iframe
                      :src="url"
                      width="100%"
                      :height="fullHeight"
                      frameborder="0"
                      scrolling="auto"
                    ></iframe>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </template>
          <template v-for="(title, index) in bigtitle">
            <el-tab-pane
              :key="index"
              label="统计类"
              name="second"
              v-if="bigtitle[index].title == '2' && formshow"
            >
              <el-tabs
                :tab-position="tabPosition"
                @tab-click="handleClick1"
                :style="styleHeight"
              >
                <el-tab-pane
                  v-for="(itemlist, index) in bigtitle[index].list"
                  :key="index"
                  :label="itemlist.code"
                >
                  <div class="pull-left" style="width: 100%">
                    <!-- 报表表单信息 Begin -->
                    <el-row>
                      <el-col
                        :span="8"
                        v-for="(item, index) in pramList"
                        :key="index"
                        v-show="item.label != ''"
                      >
                        <el-form-item
                          :label="item.label"
                          :prop="item.param"
                          :rules="{
                            required: item.required == 1 ? true : false,
                            message: '请选择',
                            trigger: 'blur,change',
                          }"
                        >
                          <el-input
                            v-model="dataInfo[item.param]"
                            v-if="item.type == '5' || item.type == '2'"
                          ></el-input>
                          <el-input-number
                            v-model.number="dataInfo[item.param]"
                            controls-position="right"
                            v-if="item.type == '8'"
                            :min="0"
                            style="width: 100%"
                          ></el-input-number>

                          <el-date-picker
                            v-model="dataInfo[item.param]"
                            v-if="item.type == '1'"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"
                            placeholder="选择日期"
                          ></el-date-picker>

                          <el-date-picker
                            v-model="dataInfo[item.param]"
                            v-if="item.type == '6'"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 100%"
                            placeholder="选择日期时间"
                          ></el-date-picker>

                          <el-date-picker
                            v-model="dataInfo[item.param]"
                            v-if="item.type == '7'"
                            value-format="yyyy"
                            format="yyyy"
                            type="year"
                            placeholder="选择年"
                            :default-value="dataInfo[item.param]"
                            style="width: 100%"
                          ></el-date-picker>

                          <el-date-picker
                            v-model="dataInfo[item.param]"
                            v-if="item.type == '8'"
                            value-format="MM"
                            format="MM"
                            type="month"
                            placeholder="选择月份"
                            :default-value="dataInfo[item.param]"
                            style="width: 100%"
                          ></el-date-picker>

                          <el-input
                            v-model="dataInfo[item.param]"
                            v-if="item.type == '3'"
                            :disabled="true"
                          >
                            <el-button
                              slot="append"
                              icon="el-icon-search"
                              @click="choose(dataInfo, item)"
                            ></el-button>
                          </el-input>

                          <el-select
                            clearable
                            v-model="dataInfo[item.param]"
                            v-if="item.type == '4'"
                            filterable
                            default-first-option
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="(data, index) in item.selectData"
                              :key="index"
                              :value="data[item.options.formselectvalue]"
                              :label="data[item.options.formselectname]"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="3"
                        class="text-center"
                        v-if="pramList.length > 0"
                      >
                        <el-button
                          type="primary"
                          size="small"
                          @click="determine"
                          >搜索</el-button
                        >
                        <el-button
                          @click="reportreset"
                          size="small"
                          style="margin-top: 2px; margin-left: 2px"
                          >重置</el-button
                        >
                      </el-col>
                    </el-row>
                    <!-- 报表表单信息 End -->

                    <iframe
                      :src="src"
                      width="100%"
                      :height="fullHeight"
                      frameborder="0"
                      scrolling="auto"
                      v-loading="loading"
                      element-loading-text="加载中…"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(255, 255, 255, 0.5)"
                    >
                    </iframe>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </template>
        </el-tabs>
      </el-form>
      <!--设备分类 Begin-->
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogAssest"
        width="60%"
      >
        <!-- 高级查询划出 Begin-->
        <div class="clearfix">
          <el-form inline-message :model="searchList" label-width="45px">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  label="分类描述"
                  prop="CLASSIFY_DESCRIPTION"
                  label-width="80px"
                >
                  <el-input
                    v-model="searchList.CLASSIFY_DESCRIPTION"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button
                  type="primary"
                  @click="searchinfo"
                  size="small"
                  style="margin-top: 2px"
                  >搜索</el-button
                >
                <el-button
                  type="primary"
                  @click="resetbtn"
                  size="small"
                  style="margin-top: 2px; margin-left: 2px"
                  >重置</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- 高级查询划出 End-->
        <div class="scrollbar" style="height: 360px">
          <!-- <tree_grid :columns="columns" :tree-structure="true" :loading="loading" :data-source="assetList" @classByValue="classByValue"></tree_grid> -->
        </div>
        <div slot="footer">
          <el-button type="primary" @click="addAssetType">确 定</el-button>
          <el-button @click="dialogAssest = false">取 消</el-button>
        </div>
      </el-dialog>
      <popupComponents
        ref="popupComponents"
        @updateChoose="updateChoose"
      ></popupComponents>
      <!--设备分类 End-->
    </div>
  </div>
</template>

<script>

// import tree_grid from "../../common/TreeGrid.vue"; //树表格
import popupComponents from "@/components/customPagesOne/customReports/popupComponents.vue";

export default {
  props: ["reportData"], //第一种方式
  components: {
    // tree_grid, //树表格
    popupComponents,
  },
  data() {
    return {
      basic_url: Config.dev_url,
      report_url: Config.report_url,
      reportsList: [], //统计类
      reportList: [], //单据类
      pramList: [],
      dataInfo: {},
      userList: [], //人名
      assetList: [], //设备分类
      options: [], //检验检测类型
      pm_typeoption: [], //年度计划的类型
      Execution_status: [], //年度计划执行状态
      stateoptions: [], //设备分类的状态
      bigtitle: [], //统计类
      //bigtitle: [], //单据类
      activeName: "",
      tabPosition: "left",
      noedit: false, //可编辑
      formshow: true,
      loading: false,
      appname: "",
      url: "", //单据
      src: "", //统计
      file: "", //统计报表事用的
      selval: [], //用户勾选
      selUser: [], //设备分类
      dialogVisible: false, //机构
      dialogVisibleuser: false, //用户
      dialogAssest: false, //设备分类
      page: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0
      },
      //获取浏览器高度
      fullHeight: document.documentElement.clientHeight - 120 + "px",
      //样式高度
      styleHeight: {
        height: document.documentElement.clientHeight - 90 + "px"
      },
      //tree树菜单
      resourceData: [], //数组，我这里是通过接口获取数据，
      resourceDialogisShow: false,
      resourceCheckedKey: [], //通过接口获取的需要默认展示的数组 [1,3,15,18,...]
      resourceProps: {
        children: "children",
        label: "fullname"
      },
      columns: [
        // {
        //   text: '编码',
        //   dataIndex: 'CLASSIFY_NUM',
        //   isShow: true,
        // },
        {
          text: "分类描述",
          dataIndex: "CLASSIFY_DESCRIPTION",
          isShow: true
        },
        {
          text: "父级分类",
          dataIndex: "PARENTDesc",
          isShow: true
        }
      ],
      //用户高级
      searchuserList: {
        nickname: "",
        username: ""
      },
      searchList: {
        //点击高级搜索后显示的内容
        CLASSIFY_NUM: "",
        CLASSIFY_DESCRIPTION: "",
        PARENT: ""
      }
    };
  },
  methods: {
    //弹出框回调
    updateChoose(data) {
      this.$forceUpdate();
    },
    //获取弹出框/下拉框配置信息
    getDialog(data) {
      var url = Config.dev_url + '/api-apps/app/applyformitemApp';
      var param = {
        page: 1,
        limit: 20,
        formnum: data.defaultVal
      }
      this.$axios.post(url, param).then((res) => {
        var dataList = res.data.datas || res.data.data || res.data
        this.$set(data, 'options', dataList[0]);
        if (data.type == '3') {
          this.getDialogParam(data);
        } else if (data.type == '4') {
          this.getSelData(data);
        }
      }).catch((wrong) => {
      })
    },
    //获取弹出框列表渲染及参数信息
    getDialogParam(data) {
      var url = Config.dev_url + '/api-apps/app/applyformitemApp/object?object=tb_inputbtnfieldsetting';
      var param = {
        page: 1,
        limit: 20,
        formnum_wheres: data.defaultVal
      }
      this.$axios.post(url, param).then((res) => {
        var dataList = res.data.datas || res.data.data || res.data
        this.$set(data.options, 'displayFieldList', dataList);
      }).catch((wrong) => {
      })
      var url1 = Config.dev_url + '/api-apps/app/applyformitemApp/object?object=tb_searchitemsetting';
      this.$axios.post(url1, param).then((res) => {
        var dataList = res.data.datas || res.data.data || res.data
        if (data.length > 0) {
          this.$set(data.options, 'searchItemList', dataList);
        } else {
          this.$set(data.options, 'searchItemList', []);
        }
      }).catch((wrong) => {
      })
    },
    //获取下拉框数据
    getSelData(data) {
      console.log(data)
      if (data.options.formgetdatamethod == '0') {
        if (!!data.options.formdictionaryCode) {  //类型编码存在
          var code = data.options.formdictionaryCode
          if (data.options.formmethod == '1') {
            var url = Config.dev_url + '/api-user/dicts/findByCode?code=' + code
            this.$axios.get(url).then((res) => {
              this.$set(data, 'selectData', res.data.subDicts);
              this.$forceUpdate();
            }).catch((err) => {
            });
          }
        }
        //数据来源：远端数据
      } else if (data.options.formgetdatamethod == '1') {
        var url1 = Config.dev_url + '/api-apps/app/applyformitemApp/object?object=tb_searchitemsetting';
        var param = {
          page: 1,
          limit: 20,
          formnum_wheres: data.defaultVal
        }
        this.$axios.post(url1, param).then((res) => {
          var dataList = res.data.datas || res.data.data || res.data
          this.$set(data.options, 'searchItemList', dataList);
          this.getRomateSeldata(data);
        }).catch((wrong) => {
        })
      }
      this.$forceUpdate();
    },
    //下拉框获取远端数据
    getRomateSeldata(data) {
      var obj = {}
      for (var i = 0; i < data.options.searchItemList.length; i++) {
        if (!!data.options.searchItemList[i].name && !!data.options.searchItemList[i].value) {  //判断查询条件参数是否存在
          obj[data.options.searchItemList[i].name] = data.options.searchItemList[i].value
        }
      }
      if (data.options.formmethod == '0') {
        var url = '';
        if (JSON.stringify(obj) == "{}") {
          url = Config.dev_url + data.options.formcustomurl
        } else {
          var str = ''
          for (let key in obj) {
            str += key + '=' + obj[key] + '&'
          }
          var params = str.substring(0, str.length - 1)
          url = Config.dev_url + data.options.formcustomurl + '?' + params
        }
        this.$axios.get(url).then((res) => {
          var dataList = res.data.datas || res.data.data || res.data
          this.$set(data, 'selectData', dataList);
        }).catch((err) => {
        });
      } else if (data.formmethod == '1') {
        var url = Config.dev_url + data.options.formcustomurl
        this.$axios.post(url, obj).then((res) => {
          var dataList = res.data.datas || res.data.data || res.data
          this.$set(data, 'selectData', dataList);
        }).catch((err) => {
        });
      }
    },
    //通用弹出框
    //通用弹出框
    choose(target, chooseParam) {
      this.$refs.popupComponents.view(target, chooseParam)
    },
    appendnames(value) {
      //客户类型(TYPE)
      var value1 = sessionStorage.getItem("R_VENDORDesc");
      var value2 = sessionStorage.getItem("R_VENDOR");
      if (value.TYPE == 1 || value.TYPE == 3) {
        this.dataInfo[value2] = value.ID + "";
        this.dataInfo[value1] = value.NAME;
      } else if (value.TYPE == 2) {
        this.dataInfo[value1] = value.fullname;
        this.dataInfo[value2] = value.id + "";
      }
    },
    // 受检企业
    getdept(parm, item) {
      sessionStorage.setItem("R_VENDORDesc", item.param); //名称
      var R_VENDOR = item.param.slice(0, -4);
      sessionStorage.setItem("R_VENDOR", R_VENDOR);
      this.$refs.enterprisechild.getData(parm);
    },
    //表头居中
    rowClass({ row, rowIndex }) {
      return "text-align:center";
    },
    SelChange(val) {
      this.selval = val;
    },
    setSel(row) {
      this.selval = [];
      this.selval.push(row);
      this.$refs.singleTable.clearSelection();
      this.$refs.singleTable.toggleRowSelection(row);
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.requestData();
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.requestData();
    },
    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return this.$moment(date).format("YYYY-MM-DD");
    },
    classByValue(childValue) {
      // childValue就是子组件传过来的
      this.selUser = childValue;
    },
    handleNodeClick(data) {
      //获取勾选树菜单节点
    },

    dailogconfirm() {
      //小弹出框确认按钮事件
      var value1 = sessionStorage.getItem("prop");
      var value2 = sessionStorage.getItem("str");
      this.dataInfo[value1] = this.getCheckboxData.fullname;
      this.dataInfo[value2] = this.getCheckboxData.id + "";
      this.dialogVisible = false;
    },
    getDept(item) {
      var id = this.$route.query.roleCode;
      // var url = Config.dev_url + '/api-user/depts/treeMap';
      var url = Config.dev_url + "/api-user/depts/getTreeMapByRoleCode/" + id;
      this.$axios
        .get(url, {})
        .then(res => {
          this.resourceData = res.data;
          this.dialogVisible = true;
          sessionStorage.setItem("prop", item.param); //名称
          var str = item.param.slice(0, -4);
          sessionStorage.setItem("str", str);
        })
        .catch(wrong => { });
    },
    //单据的切换
    singleClick(tab, event) {
      console.log(this.bigtitle, tab.label)
      this.url = "";
      var id = "";
      var file = "";
      for (var i = 0; i < this.bigtitle.length; i++) {
        console.log(this.bigtitle[i].list)
        for (var j = 0; j < this.bigtitle[i].list.length; j++) {
          if (this.bigtitle[i].list[j].code == tab.label) {
            console.log(this.bigtitle[i].list[j])
            id = this.$route.query.id;
            file = this.bigtitle[i].list[j].file;
          }
        }
      }
      var token = this.getCookie('access_token');
      this.url = this.report_url + "/ureport/preview?_u=mysql:" + file + "&id=" + id + "&access_token=" + token;
    },
    //统计的切换
    handleClick() { },
    handleClick1(tab, event) {
      console.log(tab.label);
      this.src = "";
      var id = "";
      this.pramList = []; //清空form表
      for (var i = 0; i < this.bigtitle.length; i++) {
        for (var j = 0; j < this.bigtitle[i].list.length; j++) {
          if (this.bigtitle[i].list[j].code == tab.label) {
            console.log(this.bigtitle[i].list[j])
            id = this.bigtitle[i].list[j].id;
            this.file = this.bigtitle[i].list[j].file;
          }
        }
      }
      this.appname = this.$route.query.appname;
      var url =
        Config.dev_url +
        "/api-apps/app/" +
        this.appname +
        "/reportParams/" +
        id;
      this.$axios
        .get(url, {})
        .then(res => {
          console.log("打印")
          var list = res.data.data;
          if (!!list) {
            this.formshow = true;
          } else {
            // this.formshow = false;
            var token = this.getCookie('access_token')
            this.src = this.report_url +
              "/ureport/preview?_u=mysql:" +
              this.file +
              "&access_token=" +
              token;
            console.log(this.src)
          }
          var plistsize = res.data.data.length;
          for (var i = 0; i < plistsize; i++) {
            if (
              list[i].type == "4" ||
              list[i].type == "3" ||
              list[i].type == "10" ||
              list[i].type == "12"
            ) {
              var param = list[i];
              var newparam = {};
              newparam.label = param.label;
              newparam.param = param.param;
              newparam.required = param.required;
              newparam.type = param.type;
              newparam.status = param.status;
              newparam.add = 1;
              list.push(newparam);
              list[i].label = "";
            }
          }
          this.pramList = list;
          for (var i = 0; i < this.pramList.length; i++) {
            if (this.pramList[i].type == '4' || this.pramList[i].type == '3') {
              this.getDialog(this.pramList[i]);
            }
          }
          this.dealData(list);
        })
        .catch(wrong => { });
    },
    //From表单中的数据通过param找到Value值
    dealData(data) {
      console.log(345678)
      var res = {};
      for (var i = 0; i < data.length; i++) {
        var param = data[i].param;
        if (data.type == 7) {
          this.$set(res, param, year);
        } else {
          this.$set(res, param, "");
        }
      }
      this.dataInfo = res;
    },
    //统计报表数量
    Statistics() {
      this.appname = this.$route.query.appname;
      var id = this.$route.query.id;
      //单据报表
      var url =
        Config.dev_url + "/api-apps/app/" + this.appname + "/report?type=2";
      this.$axios
        .get(url, {})
        .then(res => {
          this.reportsList = res.data.data;
          console.log(this.reportsList);
        })
        .catch(wrong => { });
    },
    //单据
    single() {
      this.appname = this.$route.query.appname;
      var url =
        Config.dev_url +
        "/api-apps/app/" +
        this.appname +
        "/report?type=1";
      this.$axios
        .get(url, {})
        .then(res => {
          this.reportList = res.data.data;
          var file = this.reportList[0].file;
          var token = this.getCookie('access_token')
          var id = this.$route.query.id;
          this.url =
            //              this.url +
            this.report_url +
            "/ureport/preview?_u=mysql:" +
            file +
            "&id=" +
            id +
            "&access_token=" +
            token;
        })
        .catch(wrong => { });
    },
    //单据的运行
    singlerun() {
      var file = this.reportList[0].file;
      var token = this.getCookie('access_token')
      var id = this.$route.query.id;
      this.url = this.report_url + "/ureport/preview?_u=mysql:" + file + "&id=" + id + "&access_token=" + token;
    },
    //运行统计报表确定
    determine() {
      this.$refs.dataInfo.validate(valid => {
        if (!valid) {
          this.$message({
            message: "未填写完整，请填写",
            type: "warning"
          });
        } else {
          this.src = "";
          var token = this.getCookie('access_token')
          console.log(this.dataInfo)
          var searchInfo = {}
          for (let key in this.dataInfo) {
            if (!!this.dataInfo[key]) {
              searchInfo[key] = this.dataInfo[key]
            }
          }
          var str = JSON.stringify(searchInfo);
          //var str=this.dataInfo;
          for (var j = 0; j < str.length; j++) {
            str = str.replace('":"', "=");
            str = str.replace('"', "");
            str = str.replace("{", "");
            str = str.replace("}", "");
            str = str.replace('","', "&");
          }

          this.str = "&" + str.replace(",", "&");
          console.log(this.file);
          var file = this.file + this.str;
          console.log(file);
          this.src = this.report_url + "/ureport/preview?_u=mysql:" + file + "&access_token=" + token;
          this.loading = false; //加载动画关闭
        }
      });
    },
    //报表的重置
    reportreset() {
      this.dataInfo = {};
      this.src = "";
    },

    //人员
    requestData(item) {
      var data = {
        page: 1,
        limit: 10,
        nickname: this.searchList.nickname,
        username: this.searchList.username
      };
      var url = Config.dev_url + "/api-user/users";
      this.$axios
        .get(url, {
          params: data
        })
        .then(res => {
          this.page.totalCount = res.data.count;
          this.userList = res.data.data;
          this.dialogVisibleuser = true;
          sessionStorage.setItem("prop", item.param); //名称
          var userid = item.param.slice(0, -4);
          sessionStorage.setItem("userid", userid);
        })
        .catch(wrong => { });
    },
    //人员的确定
    addcusname() {
      if (this.selval.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning"
        });
      } else if (this.selval.length > 1) {
        this.$message({
          message: "不可同时选择多条数据",
          type: "warning"
        });
      } else {
        var value = sessionStorage.getItem("prop");
        var value2 = sessionStorage.getItem("userid");
        this.dataInfo[value] = this.selval[0].username;
        this.dataInfo[value2] = this.selval[0].id + "";
        this.dialogVisibleuser = false;
      }
    },

    //点击设备分类选值
    addAsset(item) {
      this.loading = true; //加载动画打开
      var data = {
        page: this.page.currentPage,
        limit: this.page.pageSize,
        CLASSIFY_DESCRIPTION: this.searchList.CLASSIFY_DESCRIPTION
      };
      this.$axios
        .get(
          Config.dev_url +
          "/api-apps/app/assetClass/tree?tree_id=CLASSIFY_NUM&tree_pid=PARENT",
          {
            //要修改接口路径
            params: data
          }
        )
        .then(res => {
          //总的页数
          sessionStorage.setItem("assetid", item.param); //名称
          var asset = item.param.slice(0, -4);
          sessionStorage.setItem("asset", asset);
          this.assetList = res.data.data;
          this.dialogAssest = true;
          this.loading = false; //加载动画关闭
        })
        .catch(wrong => { });
    },
    //设备分类赋值
    addAssetType() {
      if (this.selUser.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning"
        });
      } else if (this.selUser.length > 1) {
        this.$message({
          message: "不可同时选择多条数据",
          type: "warning"
        });
      } else {
        var value = sessionStorage.getItem("assetid");
        var value2 = sessionStorage.getItem("asset");
        this.dataInfo[value] = this.selUser[0].CLASSIFY_DESCRIPTION;
        this.dataInfo[value2] = this.selUser[0].PARENT;
        this.dialogAssest = false;
      }
    },
    searchuser() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.requestData();
    },
    searchinfo() {
      //设备分类的高级查询高级搜索-搜索按钮后显示的内
      this.addAsset();
    },
    //设备分类的高级查询
    resetbtn() {
      this.searchList = {
        //点击高级搜索-重置按钮后显示的内容
        CLASSIFY_NUM: "",
        CLASSIFY_DESCRIPTION: "",
        PARENT: ""
      };
      this.requestData();
    },
    //检验检测类型
    inspectproType() {
      var url =
        Config.dev_url + "/api-user/dicts/findChildsByCode?code=BOOK_TYPE";
      this.$axios
        .get(url, {})
        .then(res => {
          this.options = res.data;
        })
        .catch(wrong => { });
    },
    //年度计划类型
    pm_type() {
      var url =
        Config.dev_url + "/api-user/dicts/findChildsByCode?code=pm_type";
      this.$axios
        .get(url, {})
        .then(res => {
          this.pm_typeoption = res.data;
        })
        .catch(wrong => { });
    },
    //年度计划执行状态
    Execution() {
      var url =
        Config.dev_url + "/api-user/dicts/findChildsByCode?code=LEADER_STATUS";
      this.$axios
        .get(url, {})
        .then(res => {
          this.Execution_status = res.data;
        })
        .catch(wrong => { });
    },
    //设备状态
    STATE() {
      var url = Config.dev_url + "/api-user/dicts/findChildsByCode?code=STATE";
      this.$axios
        .get(url, {})
        .then(res => {
          this.stateoptions = res.data;
        })
        .catch(wrong => { });
    },
    //默认加载/api-apps/app/inspectPro/reportList
    //统计

    singleAndStatistics() {
      this.appname = this.$route.query.appname;
      var url = Config.dev_url + '/api-apps/app/' + this.appname + '/reportList';

      this.$axios.get(url, {}).then((res) => {
        console.log(res);
        this.bigtitle = res.data.data;
        var bigtitle = this.bigtitle;
        console.log(bigtitle);
        if (bigtitle[0].title != "1") {
          this.activeName = "second"
        } else {
          this.activeName = "first"
        }
        for (var i = 0; i < bigtitle.length; i++) {
          console.log(bigtitle[i].title)
          var list = bigtitle[i].list;
          if (bigtitle[i].title == '1') {
            console.log('单据类')
            var token = this.getCookie('access_token')
            var id = this.$route.query.id;
            var file = list[0].file;
            console.log(list)
            this.url = this.report_url + "/ureport/preview?_u=mysql:" + file + "&id=" + id + "&access_token=" + token;
            console.log(this.url)
          } else {
            console.log('统计类')
            var id = list[0].id;
            this.file = list[0].file;
            this.utype = list[0].utype;
            var url = Config.dev_url + '/api-apps/app/' + this.appname + '/reportParams/' + id;
            this.$axios.get(url, {}).then((res) => {
              console.log(res);
              var list = res.data.data;
              if (!!list) {
                this.formshow = true;
                var plistsize = res.data.data.length;
                for (var i = 0; i < plistsize; i++) {
                  if (list[i].type == '4' || list[i].type == '10' || list[i].type == '3' || list[i].type == '12') {
                    var param = list[i];
                    var newparam = {};
                    newparam.label = param.label;
                    newparam.param = param.param;
                    newparam.required = param.required;
                    newparam.type = param.type;
                    newparam.status = param.status;
                    newparam.add = 1;
                    list.push(newparam);
                    list[i].label = '';
                  }
                }
                this.pramList = list;
                for (var i = 0; i < this.pramList.length; i++) {
                  if (this.pramList[i].type == '4' || this.pramList[i].type == '3') {
                    this.getDialog(this.pramList[i]);
                  }
                }
                this.dealData(list);
              } else {
                this.formshow = true;
                console.log(123);
                var token = this.getCookie('access_token')
                this.src = this.report_url + "/ureport/preview?_u=mysql:" + this.file + "&access_token=" + token;
                console.log(this.src);
              }
            }).catch((wrong) => {
            })
          }
        }
      }).catch((wrong) => {
      })
    },
  },
  mounted() {
    console.log('执行了')
    // this.single();
    // this.Statistics();
    this.singleAndStatistics();
    // this.inspectproType();//检验检测类型
    // this.pm_type();//年度计划类型
    // this.Execution();//年度计划执行状态
    // this.STATE();//设备状态
  }
};
</script>

<style scoped>
.content-accordion {
  margin: 15px;
}
</style>
